// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_STROLLER_ADDQUESTION = "Nov\u00e1 ot\u00e1zka - Sp\u00fdtaj sa na\u0161ej ko\u010d\u00edkovej expertky";
export const STROLLER_ADDQUESTION_HEADING = "Op\u00fdtaj sa";
export const STROLLER_SEND = "Odo\u0161li";
